<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-printer`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M35 34h5a2 2 0 002-2V13a2 2 0 00-2-2h-5V5a2 2 0 00-2-2H15a2 2 0 00-2 2v6H8a2 2 0 00-2 2v19a2 2 0 002 2h5v10a2 2 0 002 2h18a2 2 0 002-2V34zm-18-6h14v14H17V28zm11 8a1 1 0 011 1v2a1 1 0 01-1 1h-8a1 1 0 01-1-1v-2a1 1 0 011-1h8zm1-5a1 1 0 00-1-1h-8a1 1 0 00-1 1v2a1 1 0 001 1h8a1 1 0 001-1v-2zm2-24H17v4h14V7zm7 23h-3v-6H13v6h-3V15h28v15z"/></svg>
</template>
<script>

export default {
  name: 'IconPrinter',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
